export default (basePath, id) => (
  basePath.replace(':id', encodeURIComponent(id))
)



// WEBPACK FOOTER //
// ./src/util/linkToRecordByReplaceId.js